import { SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

const RequestRefundIcon = (props: SvgIconProps): JSX.Element => (
  <svg
    fill="none"
    height="39"
    viewBox="0 0 40 39"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3346 20.3351V18.8487C20.3346 17.2719 19.7082 15.7596 18.5932 14.6446C17.4782 13.5296 15.9659 12.9032 14.3891 12.9032H8.44356M8.44356 12.9032L12.9027 17.3623M8.44356 12.9032L12.9027 8.44405M26.2801 29.2534V5.47129C26.2801 4.68287 25.9669 3.92674 25.4094 3.36924C24.8519 2.81174 24.0958 2.49854 23.3074 2.49854H5.4708C4.68238 2.49854 3.92625 2.81174 3.36875 3.36924C2.81125 3.92674 2.49805 4.68287 2.49805 5.47129V29.2534L8.44356 26.2806L14.3891 29.2534L20.3346 26.2806L26.2801 29.2534Z"
      stroke="#D82662"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66567"
    />
    <circle
      cx="29.5"
      cy="28.1865"
      fill="#D82662"
      r="9.335"
      stroke="white"
      strokeWidth="1.67"
    />
    <path
      d="M26.4217 31.6865C26.4467 31.6865 26.4717 31.684 26.4967 31.6803L28.599 31.3115C28.624 31.3065 28.6477 31.2953 28.6652 31.2765L33.9634 25.9778C33.975 25.9662 33.9842 25.9525 33.9905 25.9374C33.9968 25.9222 34 25.906 34 25.8896C34 25.8733 33.9968 25.8571 33.9905 25.8419C33.9842 25.8268 33.975 25.8131 33.9634 25.8015L31.8862 23.7228C31.8624 23.699 31.8312 23.6865 31.7974 23.6865C31.7637 23.6865 31.7324 23.699 31.7087 23.7228L26.4104 29.0215C26.3917 29.0403 26.3805 29.0628 26.3755 29.0878L26.0067 31.1903C25.9946 31.2572 25.9989 31.3262 26.0194 31.3911C26.0399 31.456 26.0758 31.5149 26.1242 31.5628C26.2067 31.6428 26.3105 31.6865 26.4217 31.6865ZM27.2641 29.5065L31.7974 24.974L32.7136 25.8903L28.1803 30.4228L27.0691 30.619L27.2641 29.5065Z"
      fill="white"
    />
  </svg>
);

export const CircleRequest: FC<SvgIconProps> = (props) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8" fill="#FAAD14" r="8" />
    <path
      d="M5.60295 11.2941C5.62647 11.2941 5.65 11.2917 5.67353 11.2882L7.65215 10.9411C7.67568 10.9364 7.69803 10.9258 7.7145 10.9082L12.7011 5.92112C12.712 5.91023 12.7206 5.89731 12.7265 5.88307C12.7324 5.86884 12.7355 5.85359 12.7355 5.83818C12.7355 5.82277 12.7324 5.80751 12.7265 5.79328C12.7206 5.77905 12.712 5.76612 12.7011 5.75524L10.746 3.79877C10.7236 3.77641 10.6942 3.76465 10.6624 3.76465C10.6307 3.76465 10.6013 3.77641 10.5789 3.79877L5.59236 8.78582C5.57471 8.80347 5.56413 8.82465 5.55942 8.84818L5.2124 10.827C5.20095 10.89 5.20504 10.9549 5.22431 11.016C5.24358 11.0771 5.27744 11.1325 5.32297 11.1776C5.40061 11.2529 5.49825 11.2941 5.60295 11.2941ZM6.39581 9.24229L10.6624 4.97641L11.5247 5.83877L7.25808 10.1046L6.2123 10.2894L6.39581 9.24229Z"
      fill="white"
    />
  </svg>
);

export const CircleApproved: FC<SvgIconProps> = (props) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8" fill="#219653" r="8" />
    <g clipPath="url(#clip0_12393_202264)">
      <path
        d="M13.1225 4.57471H12.3148C12.2016 4.57471 12.0941 4.6267 12.0248 4.71567L7.26079 10.7507L4.97645 7.85622C4.94189 7.81235 4.89784 7.77687 4.84761 7.75245C4.79738 7.72804 4.74227 7.71532 4.68642 7.71525H3.87876C3.80134 7.71525 3.75859 7.80422 3.80596 7.86431L6.97077 11.8738C7.11867 12.0609 7.40292 12.0609 7.55197 11.8738L13.1952 4.72261C13.2426 4.66368 13.1999 4.57471 13.1225 4.57471Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12393_202264">
        <rect
          fill="white"
          height="10.3529"
          transform="translate(3.32324 3.11865)"
          width="10.3529"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CircleRejected: FC<SvgIconProps> = (props) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8" fill="#EB5757" r="8" />
    <path
      d="M12.4493 4.37472C12.4493 4.27658 12.3714 4.19629 12.2762 4.19629L10.8483 4.20298L8.69779 6.84598L6.54944 4.20521L5.11937 4.19852C5.02417 4.19852 4.94629 4.27658 4.94629 4.37695C4.94629 4.41933 4.96143 4.45947 4.9874 4.49293L7.8021 7.95002L4.9874 11.4049C4.96125 11.4376 4.94675 11.4785 4.94629 11.5209C4.94629 11.619 5.02417 11.6993 5.11937 11.6993L6.54944 11.6926L8.69779 9.0496L10.8461 11.6904L12.274 11.6971C12.3692 11.6971 12.4471 11.619 12.4471 11.5186C12.4471 11.4763 12.432 11.4361 12.406 11.4027L9.59564 7.94779L12.4103 4.4907C12.4363 4.45947 12.4493 4.4171 12.4493 4.37472Z"
      fill="white"
    />
  </svg>
);

export const CircleCancelled: FC<SvgIconProps> = (props) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" fill="#BDBDBD" r="8" />
    <path
      d="M11.9483 4.37472C11.9483 4.27658 11.8704 4.19629 11.7752 4.19629L10.3473 4.20298L8.19681 6.84598L6.04846 4.20521L4.61839 4.19852C4.5232 4.19852 4.44531 4.27658 4.44531 4.37695C4.44531 4.41933 4.46046 4.45947 4.48642 4.49293L7.30113 7.95002L4.48642 11.4049C4.46028 11.4376 4.44577 11.4785 4.44531 11.5209C4.44531 11.619 4.5232 11.6993 4.61839 11.6993L6.04846 11.6926L8.19681 9.0496L10.3452 11.6904L11.7731 11.6971C11.8683 11.6971 11.9462 11.619 11.9462 11.5186C11.9462 11.4763 11.931 11.4361 11.905 11.4027L9.09466 7.94779L11.9094 4.4907C11.9353 4.45947 11.9483 4.4171 11.9483 4.37472Z"
      fill="white"
    />
  </svg>
);

export default RequestRefundIcon;
